<button [ngClass]="['btn', 'btn-primary', style]" >{{ text | decodeHtmlString }}</button>
